import { Flex } from "@chakra-ui/layout";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { ModalTransferCredit } from "@components/widgets/Modals/ModalTransferCredit";
import { Trans } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import React, { type FunctionComponent, useContext } from "react";
import { ModalEditCreditAccount } from "../../form/ModalEditCreditAccount";
import type { CreditAccountModel } from "../models";
import { PageCreditAccountsCtx } from "../PageCreditAccounts";

export const PopoverRowActions: FunctionComponent<
  React.PropsWithChildren<{
    creditAccount: CreditAccountModel;
  }>
> = observer(function PopoverRowActions({ creditAccount }) {
  const store = useContext(PageCreditAccountsCtx);

  const editCreditAccountModal = useDisclosure();
  const transferCreditModal = useDisclosure();

  const router = useRouter();

  return (
    <React.Fragment>
      <Menu>
        <MenuButton>
          <Flex cursor="pointer" justify="center">
            <Icon name="dots-horizontal" color="#02929d" />
          </Flex>
        </MenuButton>
        <MenuList>
          <MenuItem {...editCreditAccountModal.getButtonProps()}>
            <Trans>Edit details</Trans>
          </MenuItem>
          <MenuItem onClick={transferCreditModal.onOpen}>
            <Trans>Transfer credit</Trans>
          </MenuItem>
        </MenuList>
      </Menu>
      <ModalEditCreditAccount
        {...editCreditAccountModal.getDisclosureProps()}
        {...editCreditAccountModal}
        creditAccount={creditAccount}
        onCompleted={() => {
          router.push(`/invoices/credit-accounts`);
        }}
      />

      <ModalTransferCredit
        {...transferCreditModal}
        brandCreditAccountId={creditAccount.id}
        onTransfer={store.refetch}
      />
    </React.Fragment>
  );
});
